export default "__VITE_PUBLIC_ASSET__b9b3654b__"